import { createColumnHelper } from "@tanstack/react-table";
import { StatusBadge } from "../ui/status-badge";
import { formatCurrency, getRelativeTime } from "../../lib/utils";
import type { AssetTableRow } from "../../types/asset-table";
import type { LifecycleStatus } from "../../types/api";

const col = createColumnHelper<AssetTableRow>();

function mapLifecycleStatus(status: LifecycleStatus): string {
  const map: Record<LifecycleStatus, string> = {
    Draft: "draft",
    Inventoried: "inventoried",
    Valued: "valued",
    "Listed for Sale": "listed-for-sale",
    "Under Offer": "under-offer",
    Sold: "sold",
    "Payment Pending": "payment-pending",
    Delivered: "delivered",
    Disposed: "disposed",
    Archived: "archived",
  };
  return map[status];
}

export const assetColumns = [
  col.accessor("unique_identifier", {
    header: "ID",
    cell: (info) => (
      <span className="font-mono text-sm">{info.getValue()}</span>
    ),
    meta: { label: "ID" },
  }),
  col.accessor("asset_nickname", {
    header: "Nickname",
    cell: (info) => (
      <span className="font-medium">{info.getValue()}</span>
    ),
    meta: { label: "Nickname" },
  }),
  col.accessor("category_name", {
    header: "Category",
    cell: (info) => (
      <span className="text-muted-foreground">
        {info.getValue() || "N/A"}
      </span>
    ),
    meta: { label: "Category", hideBelow: "md" },
  }),
  col.accessor("street_address", {
    header: "Location",
    cell: (info) => (
      <span className="text-muted-foreground">{info.getValue() || "N/A"}</span>
    ),
    meta: { label: "Location", hideBelow: "lg" },
  }),
  col.accessor("lifecycle_status", {
    header: "Status",
    cell: (info) => {
      const status = info.getValue();
      return (
        <StatusBadge status={mapLifecycleStatus(status) as any}>
          {status}
        </StatusBadge>
      );
    },
    meta: { label: "Status" },
  }),
  col.accessor("asking_price", {
    header: "Price",
    cell: (info) => formatCurrency(info.getValue()),
    meta: { label: "Price", hideBelow: "md" },
  }),
  col.accessor("updated_at", {
    header: "Updated",
    cell: (info) => (
      <span className="text-muted-foreground text-sm">
        {getRelativeTime(info.getValue())}
      </span>
    ),
    meta: { label: "Updated", hideBelow: "lg" },
  }),
];
